<script>
    import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';
</script>
<Cell><b><slot/></b></Cell>